export default __webpack_public_path__ + "static/media/react_logo.fb59dfc6.png";